import apiClient from 'api/config/apiClient'

export default {
  getTriggerEvents(payload) {
    return apiClient.request('cache-disable/trigger_events', payload)
  },
}
